import React from 'react';
import { Building2 } from 'lucide-react';
import CardBasic from '../../ui/Card.jsx';
import BasedataSettings from './BasedataSettings.jsx';

const BasedataSettingsIndex = () => {
    return (
        <div>
            <div className="mb-4">
                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                    <div>
                        <h1 className="h2 fw-bold text-dark d-flex align-items-center gap-2 mb-2">
                            <Building2 size={32} className="icon-basedata" />
                            Stammdaten
                        </h1>
                        <p className="text-muted mb-0">
                            Firmen- und Kontaktdaten, Bankverbindung und steuerliche Angaben verwalten
                        </p>
                    </div>
                </div>
            </div>
            <CardBasic>
                <BasedataSettings />
            </CardBasic>
        </div>
    );
};

export default BasedataSettingsIndex;
